/* src/app/shared/common-ui/lib/pull-to-refresh/pull-to-refresh.component.less */
:host {
  flex: 1;
  display: flex;
  flex-direction: column;
}
:host .wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}
:host .wrapper .indicator {
  flex: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0;
}
:host .wrapper .indicator .spinner {
  height: 100%;
  width: 2.8rem;
  transform: scale(0.5);
}
:host .wrapper .indicator .spinner .item {
  position: absolute;
  top: 40%;
  left: 48%;
  height: 25%;
  width: 5%;
  background: var(--color-default-text);
}
:host .wrapper .indicator .spinner .item.bar1 {
  transform: rotate(0deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner .item.bar2 {
  transform: rotate(30deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner .item.bar3 {
  transform: rotate(60deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner .item.bar4 {
  transform: rotate(90deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner .item.bar5 {
  transform: rotate(120deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner .item.bar6 {
  transform: rotate(150deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner .item.bar7 {
  transform: rotate(180deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner .item.bar8 {
  transform: rotate(210deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner .item.bar9 {
  transform: rotate(240deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner .item.bar10 {
  transform: rotate(270deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner .item.bar11 {
  transform: rotate(300deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner .item.bar12 {
  transform: rotate(330deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate {
  animation: bump 0.2s ease-out reverse;
}
:host .wrapper .indicator .spinner.activate .item {
  position: absolute;
  top: 40%;
  left: 48%;
  height: 25%;
  width: 5%;
  animation: fadeSpinnerIOS 1s linear infinite;
  background: var(--color-default-text);
  opacity: 1;
}
:host .wrapper .indicator .spinner.activate .item.bar1 {
  animation-delay: 0s;
  transform: rotate(0deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate .item.bar2 {
  animation-delay: -0.9167s;
  transform: rotate(30deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate .item.bar3 {
  animation-delay: -0.833s;
  transform: rotate(60deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate .item.bar4 {
  animation-delay: -0.7497s;
  transform: rotate(90deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate .item.bar5 {
  animation-delay: -0.667s;
  transform: rotate(120deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate .item.bar6 {
  animation-delay: -0.5837s;
  transform: rotate(150deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate .item.bar7 {
  animation-delay: -0.5s;
  transform: rotate(180deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate .item.bar8 {
  animation-delay: -0.4167s;
  transform: rotate(210deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate .item.bar9 {
  animation-delay: -0.333s;
  transform: rotate(240deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate .item.bar10 {
  animation-delay: -0.2497s;
  transform: rotate(270deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate .item.bar11 {
  animation-delay: -0.167s;
  transform: rotate(300deg) translate3d(0, -130%, 0);
}
:host .wrapper .indicator .spinner.activate .item.bar12 {
  animation-delay: -0.0833s;
  transform: rotate(330deg) translate3d(0, -130%, 0);
}
:host .wrapper .content {
  flex: 1;
  position: relative;
}
@keyframes fadeSpinnerIOS {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.25;
  }
}
@keyframes bump {
  0% {
    transform: scale(0.5);
  }
  50% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(0.5);
  }
}
/*# sourceMappingURL=pull-to-refresh.component.css.map */
